import styled from 'styled-components';
import reportPreviewBgSvg from 'assets/icons/reports-preview-bg.svg';
import { medias } from 'assets/styled/tokens';

export const BoxContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  height: 372px;
  width: 264px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  :hover {
    cursor: pointer;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.24);
  }

  @media screen and (max-width: ${medias.desktopMd}) {
    width: 100%;
    height: auto;
    gap: 10px;
  }

  @media screen and (max-width: ${medias.desktopSm}) {
    width: 100%;
    height: auto;
    gap: 10px;
  }
`;

export const KnowMoreLinkContainer = styled.div`
  width: 100%;
  button {
    display: flex;
    flex-direction: row;
    padding: 0;
    width: 100%;
    justify-content: flex-start;
    gap: 10px;
    align-items: center;
    text-decoration: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    text-transform: uppercase;
    white-space: nowrap;
    color: #888888;
    :hover {
      color: #f38a00;
      svg {
        path {
          fill: #f38a00;
        }
      }
    }
  }
`;

export const NewReport = styled.div`
  display: ${props => (props.new ? 'block' : 'none')};
  position: absolute;
  top: 0;
  left: 0;
`;
export const BoxContainerHeader = styled.div`
  background: url(${reportPreviewBgSvg}) no-repeat center/contain;
  width: 100%;
  height: 176px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  @media screen and (max-width: ${medias.desktopMd}) {
    width: 100%;
    height: 200px;
    object-fit: cover;
    background-position: center;
    background-size: cover;
  }
`;
export const PreviewImage = styled.img`
  width: 184px;
  height: 128px;
  border-radius: 2px;

  @media screen and (max-width: ${medias.tablet}) {
    transform: scale(1.2);
  }
`;
export const BoxContainerFooter = styled.div`
  width: 100%;
  padding: 0 16px 24px 16px;
  //height: 30px;
`;
export const BoxContainerMiddle = styled.div`
  padding: 0px 16px 0px 16px;
`;
export const TitleReport = styled.div`
  font-family: 'Blinker';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #1e1e1e;
  margin-bottom: 8px;
`;
export const DescriptionReport = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: #888888;
`;
